import ContactForm from '../components/ContactForm';

/**
 * Contact Page
 */
const PageContact =( $ )=>{

	if ( $( 'body' ).hasClass( 'page-template-contact' ) ) {
		ContactForm( $ );
	}

};

export default PageContact;
